import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, vModelText as _vModelText } from "vue"

const _hoisted_1 = { class: "product-item card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row p-2" }
const _hoisted_4 = { class: "col-10" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-md-8" }
const _hoisted_7 = { class: "bold mb-0" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = { class: "col-md-12" }
const _hoisted_10 = { class: "pe-5 d-inline-block" }
const _hoisted_11 = { class: "pe-5 d-inline-block" }
const _hoisted_12 = { class: "bi bi-info-circle" }
const _hoisted_13 = { class: "col-md-4 text-end" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-md-6 text-start" }
const _hoisted_16 = {
  key: 0,
  class: "discount-box"
}
const _hoisted_17 = { class: "col-md-6" }
const _hoisted_18 = { class: "bold" }
const _hoisted_19 = { class: "d-flex flex-grow-1 justify-content-end text-end" }
const _hoisted_20 = { class: "row py-3" }
const _hoisted_21 = { class: "col-md-12" }
const _hoisted_22 = { class: "row mb-1" }
const _hoisted_23 = { class: "input-group mb-3" }
const _hoisted_24 = ["title"]
const _hoisted_25 = ["title"]
const _hoisted_26 = {
  class: "form-control",
  disabled: ""
}
const _hoisted_27 = ["value"]
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = { class: "col-md-10" }
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = {
  key: 0,
  class: "small red p-2"
}
const _hoisted_33 = { class: "col-md-1" }
const _hoisted_34 = { class: "bi bi-info-circle fs-3 d-inline-block float-end" }
const _hoisted_35 = { class: "col-md-2" }
const _hoisted_36 = ["min"]
const _hoisted_37 = {
  key: 0,
  class: "small red p-2"
}
const _hoisted_38 = {
  key: 1,
  class: "small red p-2"
}
const _hoisted_39 = { class: "col-md-3" }
const _hoisted_40 = ["disabled"]
const _hoisted_41 = { class: "col-md-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VMenu = _resolveComponent("VMenu")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "col-2 d-none d-md-block" }, [
          _createElementVNode("i", { class: "bi bi-image dummy-productimage" })
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h5", _hoisted_7, _toDisplayString(_ctx.itemData.product
                    ? _ctx.getValue(_ctx.itemData.product.customerProductName)
                    : ""), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.itemData.product
                    ? _ctx.getValue(_ctx.itemData.product.customerProductNumber)
                    : "") + " " + _toDisplayString(_ctx.itemData.product.name), 1),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.itemData.product.productPackagingName), 1),
                  _createElementVNode("div", _hoisted_11, [
                    _createTextVNode(" MOQ: " + _toDisplayString(_ctx.itemData.product
                        ? _ctx.formatNumberWithSpaces(_ctx.getValue(_ctx.itemData.product.moq))
                        : "") + " boxes ", 1),
                    _withDirectives(_createElementVNode("i", _hoisted_12, null, 512), [
                      [_directive_tooltip, _ctx.moqInfoBox]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.lineDiscountSum > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, " Discount: -" + _toDisplayString(_ctx.totalDiscount), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("h5", _hoisted_18, _toDisplayString(_ctx.totalPrice), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createTextVNode(_toDisplayString(_ctx.currentPrice
                        ? _ctx.formatCurrency(
                            _ctx.getValue(_ctx.currentPrice),
                            _ctx.getValue(_ctx.itemData.product.currency)
                          )
                        : _ctx.currentPriceInfo
                        ? _ctx.formatCurrency(
                            _ctx.getValue(_ctx.currentPriceInfo.price),
                            _ctx.getValue(_ctx.itemData.product.currency)
                          )
                        : "") + " / box ", 1),
                    _cache[6] || (_cache[6] = _createElementVNode("br", null, null, -1)),
                    (_ctx.itemData.discount)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode("Discount: -" + _toDisplayString(_ctx.formatNumber(_ctx.getValue(_ctx.itemData.discount)) + "%"), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.itemData.product ? _ctx.getValue(_ctx.itemData.product.description) : ""), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Artwork version", -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ArtworkTypesconfig, (artWork) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "col-md-2",
                key: artWork.key,
                style: _normalizeStyle({
                display: _ctx.artworkSelections[artWork.key]?.id ? 'block' : 'none',
              })
              }, [
                _createVNode(_component_VMenu, null, {
                  popper: _withCtx(() => [
                    _createTextVNode(_toDisplayString(artWork.tooltip), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", {
                        class: "input-group-text",
                        title: artWork.title
                      }, [
                        _createElementVNode("i", {
                          class: _normalizeClass(artWork.icon),
                          title: artWork.title
                        }, null, 10, _hoisted_25)
                      ], 8, _hoisted_24),
                      _createElementVNode("select", _hoisted_26, [
                        _createElementVNode("option", {
                          value: _ctx.artworkSelections[artWork.key]?.id
                        }, _toDisplayString(_ctx.artworkSelections[artWork.key]?.name ||
                        "No name available"), 9, _hoisted_27)
                      ])
                    ])
                  ]),
                  _: 2
                }, 1024)
              ], 4))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[8] || (_cache[8] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Comment", -1)),
            _createElementVNode("div", _hoisted_29, [
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.artworkComment) = $event)),
                rows: "1"
              }, null, 512), [
                [_vModelText, _ctx.artworkComment]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _cache[9] || (_cache[9] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Requested Delivery", -1)),
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_Datepicker, {
                modelValue: _ctx.selectedDate,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedDate) = $event)),
                format: _ctx.dateFormat
              }, null, 8, ["modelValue", "format"]),
              (_ctx.selectedDate === null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, " Date is required "))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _withDirectives(_createElementVNode("i", _hoisted_34, null, 512), [
                [_directive_tooltip, {
                  content: _ctx.priceInfoBox,
                }]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                id: "customQuantity",
                min: _ctx.itemData.product.moq,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.customQuantity) = $event)),
                placeholder: "Enter quantity...",
                onKeyup: _cache[3] || (_cache[3] = ($event: any) => (_ctx.customQuantityChange()))
              }, null, 40, _hoisted_36), [
                [_vModelText, _ctx.customQuantity]
              ]),
              (_ctx.showNotInRange)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, " Quantity is not in quantity range "))
                : _createCommentVNode("", true),
              (
                  _ctx.customQuantity &&
                  _ctx.itemData.product.moq &&
                  _ctx.itemData.product.moq - 1 >= _ctx.customQuantity
                )
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, " Min. order quantity is " + _toDisplayString(_ctx.itemData.product.moq), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary w-100",
                disabled: 
                  _ctx.showNotInRange ||
                  (_ctx.customQuantity !== undefined && _ctx.customQuantity === 0) ||
                  _ctx.selectedDate === undefined ||
                  _ctx.selectedDate === null
                ,
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updateCart()))
              }, " Update ", 8, _hoisted_40)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("i", {
                class: "bi bi-x-lg fs-3 hand",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.removeProduct())),
                title: "Remove product"
              })
            ])
          ])
        ])
      ])
    ])
  ]))
}